export const getDescription = (description) => typeof description === 'function' ? description() : description;
//# sourceMappingURL=form-state-utils.js.map